define('areas/activityfeedconfigurator/service/activityfeedconfigurator-service',["require", "exports", "services/httpclient", "areas/activityfeedconfigurator/models/dto", "models/portal"], function (require, exports, HttpClient, dto, Portal) {
    "use strict";
    var ActivityFeedConfiguratorService = (function () {
        function ActivityFeedConfiguratorService() {
            // create the requests url
            // var serviceUrl: string = configuration.Settings.getApiFor("/breeze/mail");
        }
        ActivityFeedConfiguratorService.prototype.find = function (settings, key) {
            for (var _i = 0, settings_1 = settings; _i < settings_1.length; _i++) {
                var setting = settings_1[_i];
                if (setting.Key === key)
                    return setting;
            }
            return null;
        };
        ActivityFeedConfiguratorService.prototype.getUserOptions = function () {
            var _this = this;
            var that = this;
            return Portal.Context.shell.userManager.getSettings("activity-feed")
                .then(function (response) {
                var activityFeedServiceModel = new dto.ActivityFeedServiceModel();
                activityFeedServiceModel.SocialMediaOptions = new dto.SocialMediaOptions();
                activityFeedServiceModel.SocialMediaOptions.Hashtags = [];
                activityFeedServiceModel.SocialMediaOptions.Profiles = ["https://twitter.com/CCHvoice"];
                activityFeedServiceModel.PortalOptions = [
                    { Key: "Activation", Label: "Contact activates OneClick", Selected: true },
                    { Key: "Message", Label: "Contact sends a message", Selected: true },
                    { Key: "Document", Label: "Document is approved/rejected", Selected: true },
                    { Key: "MarkedAllAsCompleteSection", Label: "Contact marks all sources as complete in Digital Data Request", Selected: true },
                    { Key: "CompleteSection", Label: "Contact has updated a source in Digital Data Request", Selected: true },
                    { Key: "LimitDDRNotification", Label: "Please check if 1 email notification is to be received per client per day", Selected: false },
                    { Key: "CreateSection", Label: "Contact adds a new source of income in Digital Data Request", Selected: true }];
                activityFeedServiceModel.CchDailyOptions = [
                    { Key: "Tax", Label: "Tax", Selected: true },
                    { Key: "Accounting", Label: "Accounting", Selected: true },
                    { Key: "Audit", Label: "Audit", Selected: true },
                    { Key: "Insight", Label: "Insight", Selected: true },
                    { Key: "Practice Development", Label: "Practice Development", Selected: true },
                    { Key: "Professional Development", Label: "Professional Development", Selected: true }];
                if (response.toString() != "" && response != null) {
                    var settings = JSON.parse(response.toString());
                    for (var _i = 0, _a = activityFeedServiceModel.PortalOptions; _i < _a.length; _i++) {
                        var portalOption = _a[_i];
                        var option = _this.find(settings.PortalOptions, portalOption.Key);
                        if (option != null) {
                            portalOption.Selected = option.Selected;
                        }
                    }
                    for (var _b = 0, _c = activityFeedServiceModel.CchDailyOptions; _b < _c.length; _b++) {
                        var cchDailyOption = _c[_b];
                        var option = _this.find(settings.CchDailyOptions, cchDailyOption.Key);
                        if (option != null) {
                            cchDailyOption.Selected = option.Selected;
                        }
                    }
                    activityFeedServiceModel.SocialMediaOptions.Hashtags = settings.SocialMediaOptions.Hashtags;
                    activityFeedServiceModel.SocialMediaOptions.Profiles = settings.SocialMediaOptions.Profiles;
                }
                return activityFeedServiceModel;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        ActivityFeedConfiguratorService.prototype.setUserOptions = function (data) {
            var service = new HttpClient.Channel();
            return service.postDataAsync("/api/activityfeedsettings/SaveUserActivityFeedOptions", HttpClient.ServiceTarget.portalApi, data);
        };
        return ActivityFeedConfiguratorService;
    }());
    exports.ActivityFeedConfiguratorService = ActivityFeedConfiguratorService;
});

